"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQuery = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _coreV = require("@stt-componentes/core-v2");
var _reactRouterDom = require("react-router-dom");
var _constantes = _interopRequireDefault(require("./constantes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    carregando: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      width: "100%"
    }
  };
});
var useQuery = function useQuery() {
  return new URLSearchParams(window.location.search);
};
exports.useQuery = useQuery;
var SttAssinaturaDigitalPagina = function SttAssinaturaDigitalPagina() {
  var classes = useStyles();
  var query = useQuery();
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    authorizationCode = _useState2[0],
    setAuthorizationCode = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    appState = _useState4[0],
    setAppState = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    notAuthorized = _useState6[0],
    setNotAuthorized = _useState6[1];

  /**
   * Entry point
   *
   * Obtém os dados enviados através de parâmetros de URL
   */
  (0, _react.useEffect)(function () {
    // Obtém o código de autorização
    setAuthorizationCode(query.get("code"));

    // Obtém o estado da aplicação
    setAppState(query.get("state"));
  }, []);

  /**
   * Valida o state para garantir que é o mesmo enviado na solicitaçõa de autorização
   *  - Recomendado para evitar ataques CSRF
   */
  (0, _react.useEffect)(function () {
    var storedState = localStorage.getItem(_constantes["default"].STATE);
    setNotAuthorized(appState && appState !== storedState);
  }, [appState]);

  /**
   * Armazena o código de autorização e fecha a janela de interação com a API
   *  - O código será utilizado para obter o token de acesso
   *  - A janela será fechada automaticamente após 500ms
   */
  (0, _react.useEffect)(function () {
    if (authorizationCode) {
      localStorage.setItem(_constantes["default"].AUTHORIZATION_CODE, authorizationCode);
      setTimeout(function () {
        fechar();
      }, 500);
    }
  }, [authorizationCode]);

  /**
   * Fecha a janela de interação com a API
   */
  var fechar = function fechar() {
    window.close();
  };
  return notAuthorized === true ? _reactRouterDom.Redirect ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
    replace: true,
    to: "/nao-autorizado"
  }) : /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Navigate, {
    to: "/nao-autorizado",
    replace: true
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.carregando
  }, /*#__PURE__*/_react["default"].createElement(_coreV.SttCircularProgress, null));
};
var _default = SttAssinaturaDigitalPagina;
exports["default"] = _default;